module.exports = __webpack_public_path__ + "img/SEBP-DA.2c7b9789.svg";